<div class="relative mx-auto flex h-80 w-80 items-center justify-center">
  <ng-icon
    name="animatedClock"
    class="text-[19rem]"></ng-icon>
  <span class="absolute mt-auto text-center text-4xl">{{ value }}</span>
</div>
